import axios from "axios";
import { BlogApiUrls } from "./api-urls";
import globalVariables from "../global-variables";

export const GetBlogGalleryList = (p_request_object, p_success_function, navigate) => {

    //Get blog gallery List
    axios.post(globalVariables.variables.strApiUrl + BlogApiUrls.get_blog_gallery_api, p_request_object)
    .then((response_list) => {
        if(response_list.data === 'error')
        {
            navigate('/error-page')
        }
        else
        {
        // pass the result in the success function of the respective page
        p_success_function(response_list.data[0]);
        }
    });

};